import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { JoSchedularService } from 'src/app/_services/jo-schedular.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-send-email-pdf',
  templateUrl: './send-email-pdf.component.html',
  styleUrl: './send-email-pdf.component.scss',
  standalone: false
})
export class SendEmailPdfComponent implements OnInit {
 translate: any;
emailForm!: FormGroup;
emailPattern = "^[A-Za-z0-9._%+-]+@[a-z0-9.?-]+[\.]+[a-z]{2,}$";
data:any;
emailAddress: any = '';
  constructor(
    private fb: FormBuilder,
    private languageTranslateService: LanguageTranslateService,
    public modalRef : BsModalRef,
     private joSchedularService: JoSchedularService,
     private spinner:NgxSpinnerService,
     private errorUtil: ErrorUtil
  ) { }

   ngOnInit(): void {
    console.log('Modal Data:', this.data);
    debugger
    this.emailForm = this.fb.group({
      to: ['', [Validators.required, Validators.pattern(AppComponent.emailPattern)]],
      ccEmail: [[]] // array for p-chips
    });

    this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length) {
        this.translate = data;
      }
    });
  }

   isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

 submit() {
  if (this.emailForm.invalid) {
    this.emailForm.markAllAsTouched();
    return;
  }

  let ccEmailArray: string[] = [];

  if (this.emailAddress && this.emailAddress.length > 0) {
    ccEmailArray = this.emailAddress.split(',').map((email: string) => email.trim()).filter((e: string) => e);

    if (ccEmailArray.length > 2) {
      this.errorUtil.setErrorMessage(400, null, 'Maximum 2 CC email addresses allowed', 'error', 3000);
      return;
    }

    for (const email of ccEmailArray) {
      if (!this.isValidEmail(email)) {
        this.errorUtil.setErrorMessage(400, null, this.translate.general.validationFE.invalidEmailFormat, 'error', 3000);
        return;
      }
    }
  }

  const payload = {
    // ✅ Pass data from print job sheet modal
    date            : this.data?.date,
    technicianIds   : this.data?.technicianIds,
    fieldLabels     : this.data?.fieldLabels,
    // ✅ Email fields
    toEmail       : this.emailForm.value.to,
    ccEmails     : ccEmailArray.length > 0 ? ccEmailArray : null,
    
  };

  console.log('Send email payload:', payload);

  this.spinner.show();
  this.joSchedularService.sendJobSheetEmail(payload).subscribe({
    next: (res: any) => {
      this.spinner.hide();
      this.errorUtil.setErrorMessage(200, 'Job sheet sent successfully', null, 'success', 3000);
      this.modalRef.hide();
    },
    error: (err: any) => {
      console.error('Error sending email:', err.error);
      this.spinner.hide();
      this.errorUtil.setErrorMessage(err.status, null, err.error.title || 'Error sending email', 'error', 3000);
    }
  });
}
}

